export const NAV_LINKS = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Quiénes Somos', href: '#quienes-somos' },
  { label: 'Valores', href: '#valores' },
  { label: 'Nuestro Equipo', href: '#equipo' },
  { label: 'Nuestra Forma de Trabajo', href: '#forma-de-trabajo' },
  { label: 'Contacto', href: '#contacto' },
]

export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/5cc3a53c-cb48-4e77-8836-eb803a554186.jpg',
  storefront:
    'https://cdn.magicpatterns.com/uploads/7FWY1DCLBRnTEYzCefhpKY/PHOTO-2026-08-08-18-38-21.jpg',
  teamTraining:
    'https://cdn.magicpatterns.com/uploads/rqvJ6VFyyy8mR5yJBDoWFc/PHOTO-2026-08-05-22-46-22.jpg',
  teamAssembling:
    'https://cdn.magicpatterns.com/uploads/3gPcd9n3kf3MbVzdTBXUHt/PHOTO-2026-08-08-18-19-56.jpg',
  teamDelivery:
    'https://cdn.magicpatterns.com/uploads/7Y8pnq2oXB5rJ2ZbbeuJK5/PHOTO-2026-08-05-22-46-21.jpg',
  teamAdvising:
    'https://cdn.magicpatterns.com/uploads/7AuYGVSZXkhcsKJEppr6Gv/PHOTO-2026-08-10-18-55-19.jpg',
  logo: 'https://cdn.magicpatterns.com/uploads/nTrZmTTEKsk4Rev4Xvwaas/1.png',
}

export const TRUST_ITEMS = [
  {
    icon: 'award',
    title: '5 años de experiencia',
    text: 'Una trayectoria construida hogar por hogar.',
  },
  {
    icon: 'handshake',
    title: 'Atención personalizada',
    text: 'Te escuchamos antes de recomendarte.',
  },
  {
    icon: 'sparkles',
    title: 'Productos de calidad',
    text: 'Marcas seleccionadas que duran en el tiempo.',
  },
  {
    icon: 'truck',
    title: 'Entrega rápida y segura',
    text: 'Coordinada, cuidada y en tiempo.',
  },
] as const

export const VALUES = [
  'Compromiso',
  'Honestidad',
  'Calidad',
  'Responsabilidad',
  'Innovación',
  'Atención personalizada',
]

export const TEAM_PHOTOS: {
  src: string
  alt: string
  caption: string
  wide?: boolean
}[] = [
  {
    src: IMAGES.teamAdvising,
    alt: 'Asesor de Silver Hogar atendiendo a dos clientes en el escritorio del local',
    caption: 'Atención personalizada',
  },
  {
    src: IMAGES.teamAssembling,
    alt: 'Integrante del equipo de Silver Hogar armando un mueble con atornillador en el taller del local',
    caption: 'Armado de muebles',
  },
  {
    src: IMAGES.teamDelivery,
    alt: 'Equipo de Silver Hogar cargando electrodomésticos en la camioneta de reparto frente al local',
    caption: 'Preparando entregas',
  },
  {
    src: IMAGES.teamTraining,
    alt: 'Equipo de Silver Hogar reunido en una capacitación dentro del local',
    caption: 'Capacitaciones constantes',
    wide: true,
  },
]

export const PROCESS_STEPS = [
  {
    step: '01',
    icon: 'ear',
    title: 'Te escuchamos',
    text: 'Entendemos cómo vivís tu casa, tus tiempos y tu presupuesto.',
  },
  {
    step: '02',
    icon: 'compass',
    title: 'Te asesoramos',
    text: 'Te mostramos las opciones que realmente se adaptan a vos.',
  },
  {
    step: '03',
    icon: 'clipboard',
    title: 'Coordinamos tu compra',
    text: 'Definimos formas de pago, plazos y fecha de entrega.',
  },
  {
    step: '04',
    icon: 'truck',
    title: 'Entregamos en tu hogar',
    text: 'Llevamos, ubicamos y dejamos todo listo para usar.',
  },
  {
    step: '05',
    icon: 'lifebuoy',
    title: 'Seguimos acompañándote',
    text: 'Servicio postventa y respuesta cuando nos necesitás.',
  },
] as const

export const DIFFERENTIATORS = [
  {
    icon: 'heart',
    title: 'Atención cercana',
    text: 'Te atiende una persona que conoce tu historia, no un número de ticket.',
  },
  {
    icon: 'award',
    title: 'Experiencia',
    text: 'Cinco años equipando hogares nos enseñaron a recomendar bien.',
  },
  {
    icon: 'shield',
    title: 'Calidad garantizada',
    text: 'Trabajamos solo con marcas y materiales que respaldamos.',
  },
  {
    icon: 'wallet',
    title: 'Financiación',
    text: 'Planes claros y flexibles, sin letra chica ni sorpresas.',
  },
  {
    icon: 'truck',
    title: 'Entrega segura',
    text: 'Logística propia y cuidado en cada traslado hasta tu casa.',
  },
  {
    icon: 'lifebuoy',
    title: 'Servicio postventa',
    text: 'Después de la entrega seguimos disponibles para lo que surja.',
  },
] as const

export const STATS = [
  { value: '5', label: 'Años de experiencia' },
  { value: '5.000+', label: 'Hogares equipados' },
  { value: '20+', label: 'Marcas comercializadas' },
  { value: '98%', label: 'Clientes satisfechos' },
]

export const CONTACT_INFO = {
  whatsapp: '+54 9 3456 54-9507',
  whatsappUrl: 'https://wa.me/5493456549507',
  address: 'Almirante Brown 2535, Chajarí, Entre Ríos',
  hours: 'Lunes a sábados de 8:30 a 12:30 y de 16:30 a 20:30 hs',
  hoursShort: 'Lun a Sáb · 8:30–12:30 y 16:30–20:30',
  instagram: '@silverhogar.chajari',
  instagramUrl: 'https://www.instagram.com/silverhogar.chajari/',
  email: 'soportesilverhogar@gmail.com',
  mapEmbedUrl:
    'https://maps.google.com/maps?q=Almirante%20Brown%202535%2C%20Chajar%C3%AD%2C%20Entre%20R%C3%ADos%2C%20Argentina&z=16&output=embed',
  mapLinkUrl: 'https://maps.app.goo.gl/49hEa6AxZxFKjT577',
}
